<template>
  <div>
    <div class="form-group">
      <label class="col-xs-12">企業名</label>
      <div class="col-xs-12">
        <input type="text" class="form-control" v-model="params.company_name">
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12">
        <button class="btn btn-block btn-primary" v-on:click="test">検索</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        params: {
          page: 1,
          company_name: ''
        }
      }
    },
    watch: {
      params: {
        deep: true,
        handler: function () {
          this.$emit('update.params', this.params)
        }
      }
    },
    methods: {
      test: function () {
        this.params.page = 1
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Search.vue?72540812